// extracted by mini-css-extract-plugin
export default {"container":"GroupIcon-module__container--hEtuC","bordered":"GroupIcon-module__bordered--B7aIX","animatedBackground":"GroupIcon-module__animatedBackground--CVP-D"};